import Loadable from '../../components/loadable';

const BulkSendWaivers = Loadable({
  loader: () => import('../../pages/reports/bulk_send_waivers'),
});

angular.module('gym').value('BulkSendWaivers', BulkSendWaivers);

const BulkSendWaiversFiltersModal = Loadable({
  loader: () => import('../../pages/reports/bulk_send_waivers/bulk_send_waivers_filters_modal'),
  type: 'modal',
});

angular.module('gym').value('BulkSendWaiversFiltersModal', BulkSendWaiversFiltersModal);
